import {
	ArticleModel,
	CurationInfoDTO,
	ContentStreamCurateClient,
	CurationTodoDTO,
	ArticleForCurationDTO
} from "@/Generated/ParticaAPI";
import { ArticleUtils } from "./articleutils";
import { ICuratedArticle, ArticleSocial } from "@/Models/ArticleModels/article";
import { ParticaListContent, ParticaListLineContent } from "@/Models/ParticaListModel";

export interface IContentStreamCurateService {
	getArticleForCuration(id: string): Promise<ICuratedArticle>;
	GetCurationInfo(ArticleId: string): Promise<CurationInfoDTO>;
	DeleteArticle(ArticleId: string): Promise<any>;
	SaveCuratingArticle(article: ICuratedArticle): Promise<ICuratedArticle>;
	SaveSourceArticle(article: ICuratedArticle): Promise<ICuratedArticle>;
	MarkArticleCurated(articleId: string): Promise<any>;
	GetOutstandingWorkStats(customerAccountId: number): Promise<ParticaListContent>;
	GetArticlesForCuration(query: ArticleForCurationDTO): Promise<CurationTodoDTO[]>;
}

export class ContentStreamCurateService implements IContentStreamCurateService {
	private svc: ContentStreamCurateClient = new ContentStreamCurateClient();
	private articleUtils: ArticleUtils = new ArticleUtils();

	public async DeleteArticle(ArticleId: string): Promise<any> {
		await this.svc.deleteArticle(ArticleId);
	}

	public async GetArticlesForCuration(query: ArticleForCurationDTO): Promise<CurationTodoDTO[]> {
		const data = await this.svc.getArticleForCurationAll(query);
		return data;
	}

	public async GetOutstandingWorkStats(customerAccountId: number): Promise<ParticaListContent> {
		const data = await this.svc.getOutstandingContentStreamWork(customerAccountId);
		const result: ParticaListContent = new ParticaListContent();
		result.title = "Outstanding Work";
		data.forEach(level => {
			const line = new ParticaListLineContent();
			line.title = level.stream + " : " + level.level;
			const curationValue: number = (level.price as number) * 0.70;
			line.subtitle = `${level.numberArticles} article(s) @ $${curationValue.toFixed(2)} per article`;
			line.right = `$${((level.numberArticles as number) * curationValue).toFixed(2)}`;
			result.lines.push(line);
		});
		return result;

	}
	public async GetCurationInfo(ArticleId: string): Promise<CurationInfoDTO> {
		return await this.svc.getCurationInfoForArticle(ArticleId);
	}

	public async SaveCuratingArticle(article: ICuratedArticle): Promise<ICuratedArticle> {
		const am: ArticleModel = article.get<ArticleModel>();
		am.issue = undefined;
		const result = await this.svc.saveCuratingArticle(am);
		return this.articleUtils.convertarticle<ICuratedArticle>(result);
	}

	public async SaveSourceArticle(article: ICuratedArticle): Promise<ICuratedArticle> {
		const am: ArticleModel = article.get<ArticleModel>();
		am.issue = undefined;
		const result = await this.svc.saveSourceArticle(am);
		return this.articleUtils.convertarticle<ICuratedArticle>(result);
	}

	public async MarkArticleCurated(articleId: string): Promise<any> {
		return await this.svc.markArticleCurated(articleId);
	}

	public async getArticleForCuration(id: string): Promise<ICuratedArticle> {
		const article = await this.svc.getArticleForCuration(id);
		const curate: ICuratedArticle = this.articleUtils.convertarticle<ICuratedArticle>(article);
		if (curate.articleSocials === undefined) {
			curate.articleSocials = new ArticleSocial();
			curate.articleSocials.articleSocialId = curate.id;
		}
		return curate;
	}
}
